<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="YongHuList" data-title="">
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        style="--el-border-radius-base: 16px; --el-segmented-bg-color: #f9f9f9"
        :options="[{ Text: '全部' }, ...$base.Common_Status]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :min-width="260">
          <template #header>
            <div class="c-table-col-header" label1="标题" label2="发布信息" />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <strong>{{ row.title }}</strong>
              </template>
              <template #bottom>
                <div class="flex items-end text-gray-400 text-xs gap-x-2">
                  <text class="text-sm text-gray-600">{{
                    row.add_admin_name
                  }}</text>
                  <text>{{ row.add_department_name }}</text>
                  <text class="ml-1">{{ row.create_time + " 创建" }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :min-width="120">
          <template #header>
            <div class="c-table-col-header" label1="发布日期" label2="类型" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.release_date"
              :value2="row.d_news_type_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="介绍"
          prop="description"
          :formatter="$tab_TextFormat"
          :width="120"
          align="center"
        />
        <el-table-column label="是否置顶" align="center">
          <template #default="{ row }">
            <el-checkbox
              v-model="row.is_top"
              :true-value="1"
              :false-value="0"
              @change="onUpdateIsTop($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template #default="{ row }">
            <el-switch
              v-model="row.status"
              active-text="启用"
              inactive-text="禁用"
              :active-value="1"
              :inactive-value="0"
              :disabled="!row.id"
              inline-prompt
              @change="onUpdateStatus($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="320">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑新闻' : '新建新闻'"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    append-to=".dialog-dom"
  >
    <c_info
      :id="state.selectId"
      :meeting_id="props.meeting_id"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_website_news_page,
  meeting_website_news_updateStatus,
  meeting_website_news_updateIsTop,
  meeting_website_news_delete,
} from "@/http/meeting";
import { onDeleteConfirm, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      meeting_website_news_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_website_news_delete, row.id, onLoad, {
        filed: "网站新闻",
        name: row.title,
      });
    };

    //启停
    const onUpdateStatus = (value, row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 1
            ? '<strong style="color: var(--el-color-success);">启用</strong>'
            : '<strong style="color: var(--el-color-danger);">禁用</strong>'
        }该新闻吗？`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          meeting_website_news_updateStatus({
            id: row.id,
            status: row.status,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.status = value ? 0 : 1;
        });
    };

    //置顶
    const onUpdateIsTop = (value, row) => {
      ElMessageBox.confirm(
        `您确定${
          row.is_top == 1
            ? '<strong style="color: var(--el-color-success);">置顶</strong>'
            : '<strong style="color: var(--el-color-danger);">取消置顶</strong>'
        }该新闻吗？`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          meeting_website_news_updateIsTop({
            id: row.id,
            is_top: row.is_top,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.is_top = value ? 0 : 1;
        });
    };

    return { state, props, onLoad, onDelete, onUpdateStatus, onUpdateIsTop };
  },
};
</script>

<style lang="scss" scoped></style>
